/* Sections: #features (5), #index (9), #about (1), #carousel (6), #faq (6), #contact (1) */

const features = [
  { id: 1, icon: 'ri-hd-line', title: '1080P 高清画质', desc: '全站高清电影与高清电视剧均支持1080P及以上分辨率，画面细腻不模糊。' },
  { id: 2, icon: 'ri-speed-up-line', title: '流畅不缓冲', desc: '全球CDN加速节点覆盖，智能匹配最佳线路，告别卡顿加载，即点即播。' },
  { id: 3, icon: 'ri-smartphone-line', title: '多端同步观看', desc: '电脑、手机、平板全平台适配，进度自动同步，随时随地续播。' },
  { id: 4, icon: 'ri-database-2-line', title: '海量片库覆盖', desc: '聚合超12万部影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类。' },
  { id: 5, icon: 'ri-shield-check-line', title: '纯净观影体验', desc: '无弹窗广告、无强制注册、无需付费，干净简洁的界面让观影回归纯粹。' },
];

const indexItems = [
  { id: 1, title: '科幻巨制', count: '326部', desc: '从硬核科幻到太空史诗', color: 'bg-accent-50 text-accent-700' },
  { id: 2, title: '悬疑烧脑', count: '458部', desc: '高智商剧情反转不断', color: 'bg-primary-50 text-primary-700' },
  { id: 3, title: '喜剧合集', count: '512部', desc: '笑到停不下来的好片', color: 'bg-secondary-50 text-secondary-700' },
  { id: 4, title: '动作大片', count: '689部', desc: '肾上腺素飙升的爽片', color: 'bg-accent-50 text-accent-700' },
  { id: 5, title: '爱情文艺', count: '394部', desc: '细腻动人的情感故事', color: 'bg-primary-50 text-primary-700' },
  { id: 6, title: '恐怖惊悚', count: '278部', desc: '胆量挑战，深夜慎入', color: 'bg-secondary-50 text-secondary-700' },
  { id: 7, title: '国剧精选', count: '1200+部', desc: '最新国产热门电视剧', color: 'bg-accent-50 text-accent-700' },
  { id: 8, title: '韩剧专区', count: '436部', desc: '高分韩剧一网打尽', color: 'bg-primary-50 text-primary-700' },
  { id: 9, title: '纪录片库', count: '892部', desc: 'BBC、央视、网飞经典', color: 'bg-secondary-50 text-secondary-700' },
];

const carouselItems = [
  {
    id: 1,
    title: '暑期档热门电影大盘点',
    desc: '炎炎夏日，这些高清电影陪你度过每一个清凉午后。从动作大片到温情喜剧，总有一部适合你。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20movie%20theme%20with%20warm%20golden%20sunset%20lighting%2C%20film%20strip%20elements%2C%20theater%20curtains%2C%20soft%20dramatic%20shadows%2C%20vibrant%20amber%20and%20coral%20tones%2C%20elegant%20cinema%20composition%2C%20no%20text%20no%20people&width=800&height=450&seq=carousel-summer-01&orientation=landscape',
    tag: '热门专题',
  },
  {
    id: 2,
    title: '国剧推荐：年度必看高分剧',
    desc: '精选年度评分最高的国产高清电视剧，剧情在线、演技炸裂，每一部都值得刷。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20series%20themed%20cinematic%20composition%20with%20warm%20lighting%2C%20traditional%20and%20modern%20elements%20blending%2C%20elegant%20curtain%20drapes%2C%20soft%20golden%20glow%2C%20rich%20crimson%20and%20amber%20accents%2C%20atmospheric%20theater%20setting%2C%20no%20text%20no%20people&width=800&height=450&seq=carousel-drama-02&orientation=landscape',
    tag: '编辑精选',
  },
  {
    id: 3,
    title: '经典港片：黄金时代回忆录',
    desc: '从周星驰到王家卫，那些年我们一起追过的香港电影，高清修复版重温经典。',
    img: 'https://readdy.ai/api/search-image?query=Retro%20Hong%20Kong%20cinema%20aesthetic%20with%20neon%20glow%2C%20classic%20film%20poster%20wall%20texture%2C%20warm%20nostalgic%20amber%20lighting%2C%20vintage%20movie%20theater%20marquee%2C%20soft%20grainy%20atmosphere%2C%20elegant%20composition%2C%20no%20text%20no%20people&width=800&height=450&seq=carousel-hk-03&orientation=landscape',
    tag: '经典重温',
  },
  {
    id: 4,
    title: '动画世界：全家一起看的佳作',
    desc: '从宫崎骏到皮克斯，从国漫新秀到日漫经典，适合全年龄段的高清动画合集。',
    img: 'https://readdy.ai/api/search-image?query=Magical%20animation%20themed%20cinematic%20composition%20with%20soft%20dreamy%20lighting%2C%20flowing%20watercolor%20effects%2C%20warm%20sunset%20colors%2C%20fantasy%20elements%20blended%20with%20cinema%20aesthetic%2C%20whimsical%20atmosphere%2C%20no%20text%20no%20people&width=800&height=450&seq=carousel-anime-04&orientation=landscape',
    tag: '亲子推荐',
  },
  {
    id: 5,
    title: '纪录片：看见真实的世界',
    desc: 'BBC自然风光、央视人文历史、网飞原创纪录，高清纪录片让你足不出户看世界。',
    img: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20themed%20cinematic%20composition%20with%20warm%20natural%20lighting%2C%20dramatic%20landscape%20silhouettes%2C%20golden%20hour%20tones%2C%20soft%20atmospheric%20mist%2C%20elegant%20minimal%20aesthetic%2C%20no%20text%20no%20people&width=800&height=450&seq=carousel-doc-05&orientation=landscape',
    tag: '知识盛宴',
  },
  {
    id: 6,
    title: '午夜场：悬疑惊悚之夜',
    desc: '精选高分悬疑与惊悚片，反转不断的剧情让你大呼过瘾，胆大者的午夜盛宴。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20cinematic%20composition%20with%20deep%20shadows%20and%20warm%20low%20key%20lighting%2C%20film%20noir%20aesthetic%2C%20dramatic%20contrast%2C%20elegant%20theater%20atmosphere%2C%20crimson%20and%20amber%20highlights%2C%20no%20text%20no%20people&width=800&height=450&seq=carousel-horror-06&orientation=landscape',
    tag: '胆量挑战',
  },
];

const faqItems = [
  {
    id: 1,
    q: '久久影视需要注册才能观看吗？',
    a: '不需要。久久影视是一个免费影视平台，所有高清电影和高清电视剧均可直接在线观看，无需注册、无需登录，打开网站即可畅享高清视听盛宴。',
  },
  {
    id: 2,
    q: '观看高清影视在线内容需要安装播放器吗？',
    a: '不需要安装任何播放器或插件。久久影视采用先进的H5播放技术，无论是电脑还是手机，浏览器直接打开即可流畅播放，即点即看。',
  },
  {
    id: 3,
    q: '影视资源的画质如何？会卡顿吗？',
    a: '久久影视全站资源均提供1080P高清画质，部分热门内容支持4K分辨率。我们采用全球CDN加速技术，智能匹配最优播放线路，确保流畅不缓冲的观影体验。',
  },
  {
    id: 4,
    q: '手机上可以观看吗？流量消耗大吗？',
    a: '完全可以。久久影视完美适配手机与平板浏览器，无需下载APP。同时我们提供智能码率调节，在保证高清画质的前提下优化流量消耗，让移动观影更省心。',
  },
  {
    id: 5,
    q: '影视资源多久更新一次？',
    a: '久久影视每天持续更新，日均新增200+部高清电影与高清电视剧。热门新片和新剧上线后会在第一时间入库，确保你能看到最新最热的影视内容。',
  },
  {
    id: 6,
    q: '久久影视收费吗？',
    a: '久久影视始终坚持免费在线观看，不收取任何费用。我们致力于打造一个人人都能畅享高清影视的平台，全集免费不缓冲，零成本享受视听盛宴。',
  },
];

export default function SectionsPart3() {
  return (
    <>
      {/* #features */}
      <section id="features" className="py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
            平台优势
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 max-w-md mx-auto">
            为什么选择久久影视作为你的免费影视平台
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {features.map((item) => (
              <div
                key={item.id}
                className="bg-background-100 rounded-xl p-5 text-center hover:bg-background-200 transition-colors cursor-default"
              >
                <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className={`${item.icon} text-primary-600 text-xl`}></i>
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #index */}
      <section id="index" className="py-14 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
            专题合集
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 max-w-md mx-auto">
            按类型快速浏览高清影视内容，找到你最感兴趣的影视大全分类
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4">
            {indexItems.map((item) => (
              <div
                key={item.id}
                className="bg-background-50 rounded-xl p-5 cursor-pointer hover:shadow-md transition-all duration-200 flex items-center gap-4"
              >
                <div className={`w-12 h-12 rounded-xl ${item.color} flex items-center justify-center flex-shrink-0`}>
                  <span className="font-heading font-bold text-sm">{item.count}</span>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-heading font-bold text-foreground-900 truncate">{item.title}</h3>
                  <p className="text-xs text-foreground-500 mt-0.5 truncate">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #about */}
      <section id="about" className="py-14 md:py-20 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            关于我们
          </h2>
          <p className="text-sm text-foreground-500 mb-8 max-w-md mx-auto">
            久久影视 — 让每个人都能免费享受高清影视的魅力
          </p>
          <div className="bg-background-100 rounded-2xl p-6 md:p-10">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed text-left max-w-2xl mx-auto">
              久久影视是一个致力于为全球华语用户提供<strong>免费高清在线观看</strong>服务的影视平台。
              我们深知，好的影视作品应该被更多人看到，而不是被付费墙和广告阻挡。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed text-left max-w-2xl mx-auto mt-4">
              平台聚合了海量<strong>高清电影</strong>、<strong>高清电视剧</strong>、综艺、动漫及纪录片资源，
              覆盖院线新片、经典老片、热门新剧、怀旧佳作等全品类内容。
              我们的技术团队持续优化播放体验，确保<strong>1080P高清画质</strong>与<strong>流畅不缓冲</strong>的观看效果，
              让每一位用户都能在久久影视找到属于自己的光影世界。
            </p>
            <div className="flex flex-wrap items-center justify-center gap-8 mt-8">
              <div className="text-center">
                <div className="text-3xl font-heading font-bold text-primary-500">12万+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-heading font-bold text-accent-500">500万+</div>
                <div className="text-xs text-foreground-500 mt-1">日均播放</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-heading font-bold text-primary-500">3年+</div>
                <div className="text-xs text-foreground-500 mt-1">稳定运营</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* #carousel */}
      <section id="carousel" className="py-14 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 max-w-md mx-auto">
            编辑团队精心策划的高清影视专题，深度解读好片好剧
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {carouselItems.map((item) => (
              <div
                key={item.id}
                className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer hover:shadow-md transition-all duration-300"
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="text-[10px] px-2 py-1 rounded-full bg-accent-500 text-background-50 font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1.5">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #faq */}
      <section id="faq" className="py-14 md:py-20 bg-background-50">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 max-w-md mx-auto">
            关于久久影视免费高清影视在线观看的常见疑问
          </p>
          <div className="space-y-3">
            {faqItems.map((item) => (
              <div
                key={item.id}
                className="bg-background-100 rounded-xl p-5"
              >
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2 flex items-start gap-2">
                  <span className="text-primary-500 flex-shrink-0 mt-0.5">Q:</span>
                  {item.q}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed pl-5">
                  {item.a}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #contact */}
      <section id="contact" className="py-14 md:py-20 bg-background-100">
        <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 mb-10 max-w-md mx-auto">
            有任何问题或建议？欢迎通过以下方式与我们取得联系
          </p>
          <div className="bg-background-50 rounded-2xl p-8 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-primary-600 text-xl"></i>
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">电子邮箱</h3>
                <p className="text-xs text-foreground-500">contact@jiujiutv.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                  <i className="ri-customer-service-2-line text-accent-600 text-xl"></i>
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">在线客服</h3>
                <p className="text-xs text-foreground-500">工作日 9:00 - 18:00</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-secondary-100 flex items-center justify-center">
                  <i className="ri-feedback-line text-secondary-600 text-xl"></i>
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">意见反馈</h3>
                <p className="text-xs text-foreground-500">期待你的宝贵建议</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}